import { RowItemType, Section, UIElementType } from '../../../models';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { ForeSiteRadarSensorFieldIds } from '../base-config-models';
import { MonitorSeriesNames } from 'app/shared/components/location-card/location-card.constants';
import { InstallationSeries } from 'app/shared/models/location-details';
import { field } from '../../../core/field-schema';
import { pattern } from '../../../core/validator-builders';
import { ForesiteXDLocationCardState } from '../models';
import { foresiteXdMaxRangeChange } from '../../../actions';

export const foreSiteRadarSensor = (state: ForesiteXDLocationCardState): Section => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;
    const config = state.monitorConfiguration;
    const settings = state.settings;
    const isChannelInstallation = details?.installationShapeTypeID === InstallationSeries.Channel;

    const isEditMode = !!config && config.devices && config.devices.length > 0;
    const radarValues = isEditMode ? config.devices[0] : null;
    const isSwitchMonitor = details && details.series.toLowerCase() !== MonitorSeriesNames.ForeSITE_XD.toLowerCase();

    const currentRange = radarValues && !isSwitchMonitor
        ? (settings.isMetric ? Math.round(radarValues.maxMeasurementRange) : radarValues.maxMeasurementRange)
        : 6000;

    return {
        info: {
            id: 'foresite-radar-sensor-section',
            title: 'RADAR',
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: 'echo-section',
        },
        rows: [
            {
                info: {
                    id: 'radar-sensor-row',
                    panelClass: 'custom-50p pad-b-15',
                },
                items: [
                    field.range(ForeSiteRadarSensorFieldIds.MaxMeasurementRange, 'maxMeasurementRange', {
                        label: 'ADD_EDIT.MAX_RANGE',
                        value: currentRange,
                        min: 6000,
                        max: 12000,
                        step: 6000,
                        panelClass: 'each-Item',
                        rangeTextMap: {
                            6000: 'NORMAL (0 - 19.5 ft)',
                            12000: 'HIGH (19.6 - 39.3 ft)',
                        },
                        events: {
                            onChange: (value: number) => [foresiteXdMaxRangeChange({ value })],
                        },
                    }),

                    field.number(ForeSiteRadarSensorFieldIds.PhysicalOffset, 'physicalOffset', {
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_PHYSICAL',
                        placeholderSuffix: settings.depthUnit,
                        panelClass: 'each-Item',
                        value: isChannelInstallation ? 0 : (radarValues && !isSwitchMonitor ? Number(radarValues.physicalOffset) : 0),
                        disabled: isChannelInstallation,
                        validators: [
                            pattern({
                                value: settings.isMetric
                                    ? REGEX_CONFIG.numericWith1DecimalPlaces
                                    : REGEX_CONFIG.numericWith2DecimalPlaces,
                                message: settings.isMetric
                                    ? 'COMMON.NUMERIC_PRECISION_ERROR_1_DECIMAL'
                                    : 'COMMON.NUMERIC_PRECISION_ERROR_2_DECIMALS',
                            }),
                        ],
                    }),
                ],
            },
            {
                info: {
                    id: 'max-range-warning-row',
                    panelClass: '',
                },
                items: [
                    {
                        id: ForeSiteRadarSensorFieldIds.MaxRangeWarning,
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'maxRangeWarning',
                        visible: currentRange === 12000,
                        panelClass: 'mat-error mt-3',
                        label: 'COMMON.MAX_RANGE_SELECTED',
                    },
                ],
            },
        ],
    };
};
